import { render, staticRenderFns } from "./QuotePartsControlNotOrdered.vue?vue&type=template&id=a15d21b6&scoped=true"
import script from "./QuotePartsControlNotOrdered.vue?vue&type=script&lang=js"
export * from "./QuotePartsControlNotOrdered.vue?vue&type=script&lang=js"
import style0 from "./QuotePartsControlNotOrdered.vue?vue&type=style&index=0&id=a15d21b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15d21b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a15d21b6')) {
      api.createRecord('a15d21b6', component.options)
    } else {
      api.reload('a15d21b6', component.options)
    }
    module.hot.accept("./QuotePartsControlNotOrdered.vue?vue&type=template&id=a15d21b6&scoped=true", function () {
      api.rerender('a15d21b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/partsControl/unorderedparts/QuotePartsControlNotOrdered.vue"
export default component.exports